var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { instance } from './index';
var QUOTE_URL = '/widget/quote';
var create = function (_a) {
    var customerID = _a.customerID, saasId = _a.saasId, items = _a.items, productId = _a.productId, externalID = _a.externalID, quoteExternalId = _a.quoteExternalId, _b = _a.formVersion, formVersion = _b === void 0 ? 'list' : _b;
    return instance({
        method: 'POST',
        url: "".concat(QUOTE_URL, "?externalId=").concat(encodeURIComponent(externalID), "&formVersion=").concat(formVersion),
        data: {
            customerId: customerID,
            saasId: saasId,
            externalId: quoteExternalId,
            productId: productId,
            items: items
        }
    });
};
var brizaMarkActive = function (_a) {
    var customerId = _a.customerId, externalQuoteId = _a.externalQuoteId, quoteId = _a.quoteId, type = _a.type;
    var data = {};
    if (customerId) {
        data['customerId'] = customerId;
    }
    if (externalQuoteId) {
        data['externalQuoteId'] = externalQuoteId;
    }
    if (quoteId) {
        data['quoteId'] = quoteId;
    }
    if (type) {
        data['type'] = type;
    }
    var url = "briza/coverage-ack/active";
    return instance({
        method: 'POST',
        url: "".concat(QUOTE_URL, "/briza/coverage-ack/active"),
        data: data
    });
};
var upsertDraft = function (_a) {
    var customerID = _a.customerID, saasId = _a.saasId, items = _a.items, productId = _a.productId, externalID = _a.externalID, quoteExternalId = _a.quoteExternalId, _b = _a.finaliseQuote, finaliseQuote = _b === void 0 ? false : _b, unifiedAction = _a.unifiedAction, quoteId = _a.quoteId, _c = _a.formVersion, formVersion = _c === void 0 ? 'list' : _c, parentQuoteId = _a.parentQuoteId;
    var data = {};
    if (customerID) {
        data['customerId'] = customerID;
    }
    if (saasId) {
        data['saasId'] = saasId;
    }
    if (quoteExternalId) {
        data['externalId'] = quoteExternalId;
    }
    if (productId) {
        data['productId'] = productId;
    }
    var url = "draft".concat(quoteId ? "/".concat(quoteId) : '');
    return instance({
        method: quoteId ? 'PUT' : 'POST',
        url: "".concat(QUOTE_URL, "/").concat(url, "?externalId=").concat(encodeURIComponent(externalID), "&formVersion=").concat(formVersion),
        data: __assign(__assign({}, data), { finaliseQuote: finaliseQuote, unifiedAction: unifiedAction, parentQuoteId: parentQuoteId, items: items })
    });
};
var ackQuote = function (_a) {
    var quoteId = _a.quoteId;
    return instance({
        method: 'PUT',
        url: "".concat(QUOTE_URL, "/acknowledge"),
        data: {
            quoteId: quoteId
        }
    });
};
var submitForManualReview = function (_a) {
    var quoteId = _a.quoteId;
    return instance({
        method: 'PUT',
        url: "".concat(QUOTE_URL, "/manualReview"),
        data: {
            quoteId: quoteId
        }
    });
};
// add this in new lambda
var createNotification = function (_a) {
    var customerID = _a.customerID, saasId = _a.saasId, items = _a.items, productId = _a.productId, externalID = _a.externalID, quoteExternalId = _a.quoteExternalId, policyId = _a.policyId;
    return instance({
        method: 'POST',
        url: "".concat(QUOTE_URL, "/notification?externalId=").concat(encodeURIComponent(externalID)),
        data: {
            customerId: customerID,
            saasId: saasId,
            externalId: quoteExternalId,
            policyId: policyId,
            productId: productId,
            items: items
        }
    });
};
// add this in new lambda
var getCustomerQuotes = function (_a) {
    var customerID = _a.customerID, policyId = _a.policyId, externalId = _a.externalId;
    var url = "".concat(QUOTE_URL, "/customer-quotes/").concat(customerID, "?externalId=").concat(encodeURIComponent(externalId));
    if (policyId) {
        url += "&policyId=".concat(policyId);
    }
    return instance({
        method: 'GET',
        url: url
    });
};
var update = function (_a) {
    var quoteID = _a.quoteID, customerID = _a.customerID, saasId = _a.saasId, items = _a.items, productId = _a.productId, externalID = _a.externalID;
    return instance({
        method: 'PUT',
        url: "".concat(QUOTE_URL, "/").concat(quoteID, "?externalId=").concat(encodeURIComponent(externalID)),
        data: {
            customerId: customerID,
            saasId: saasId,
            productId: productId,
            items: items
        }
    });
};
var submitLimitApplication = function (_a) {
    var quoteId = _a.quoteId, answers = _a.answers;
    return instance({
        method: 'POST',
        url: "".concat(QUOTE_URL, "/").concat(quoteId, "/submit-limit-application"),
        data: {
            answers: answers
        }
    });
};
var getLimitApplicationPolicies = function (_a) {
    var quoteId = _a.quoteId;
    return instance({
        method: 'GET',
        url: "".concat(QUOTE_URL, "/").concat(quoteId, "/limit-application-policies")
    });
};
var bindLimitApplicationPolicy = function (_a) {
    var quoteId = _a.quoteId, limitPolicyId = _a.limitPolicyId;
    return instance({
        method: 'POST',
        url: "".concat(QUOTE_URL, "/").concat(quoteId, "/bind"),
        data: {
            limitPolicyId: limitPolicyId
        }
    });
};
// add this in new lambda
var listLimitPolicyDocuments = function (_a) {
    var quoteId = _a.quoteId, limitPolicyId = _a.limitPolicyId;
    return instance({
        method: 'GET',
        url: "".concat(QUOTE_URL, "/").concat(quoteId, "/documents?limitPolicyId=").concat(limitPolicyId)
    });
};
var uploadLimitPolicyDocument = function (_a) {
    var quoteId = _a.quoteId, limitPolicyId = _a.limitPolicyId, docusealId = _a.docusealId, documentName = _a.documentName, documentId = _a.documentId;
    var url = "".concat(QUOTE_URL, "/").concat(quoteId, "/documents?limitPolicyId=").concat(limitPolicyId);
    var data = __assign(__assign({ limitPolicyId: limitPolicyId, docusealId: docusealId }, (documentName ? { documentName: documentName } : {})), (documentId ? { documentId: documentId } : {}));
    return instance({
        method: 'POST',
        url: url,
        data: data
    });
};
var getPresignedSubmissionUrls = function (_a) {
    var files = _a.files, quoteId = _a.quoteId, externalID = _a.externalID;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            data = {
                quoteId: quoteId,
                files: files.map(function (file) { return ({
                    name: file.name,
                    type: file.type,
                    size: file.size
                }); })
            };
            return [2 /*return*/, instance({
                    method: 'POST',
                    url: "".concat(QUOTE_URL, "/upload-submission-presigned-urls?externalId=").concat(encodeURIComponent(externalID)),
                    data: data
                })];
        });
    });
};
var uploadSubmission = function (_a) {
    var files = _a.files, quoteId = _a.quoteId, externalID = _a.externalID;
    return __awaiter(void 0, void 0, void 0, function () {
        var formData;
        return __generator(this, function (_b) {
            formData = new FormData();
            formData.append('quoteId', quoteId);
            files.forEach(function (file) {
                formData.append('files', file);
            });
            return [2 /*return*/, instance({
                    method: 'POST',
                    url: "".concat(QUOTE_URL, "/upload-submission?externalId=").concat(encodeURIComponent(externalID)),
                    data: formData
                })];
        });
    });
};
var deleteCustomerSubmissionFiles = function (_a) {
    var files = _a.files;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2 /*return*/, instance({
                    method: 'DELETE',
                    url: "".concat(QUOTE_URL, "/delete-customer-submission-files"),
                    data: {
                        fileKeys: files
                    }
                })];
        });
    });
};
var uploadSignature = function (_a) {
    var signature = _a.signature, quoteId = _a.quoteId, formKey = _a.formKey, externalID = _a.externalID;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2 /*return*/, instance({
                    method: 'POST',
                    url: "".concat(QUOTE_URL, "/upload-signature?externalId=").concat(encodeURIComponent(externalID)),
                    data: {
                        signature: signature,
                        quoteId: quoteId,
                        formKey: formKey
                    }
                })];
        });
    });
};
var listRacetracPolicyDocuments = function (_a) {
    var quoteId = _a.quoteId;
    return instance({
        method: 'GET',
        url: "".concat(QUOTE_URL, "/racetrac/documents/").concat(quoteId)
    });
};
var getSignatureDocuments = function (_a) {
    var quoteId = _a.quoteId;
    return instance({
        method: 'GET',
        url: "".concat(QUOTE_URL, "/documents/").concat(quoteId)
    });
};
var getBrizaStatesClassCodes = function () {
    return instance({
        method: 'GET',
        url: "".concat(QUOTE_URL, "/briza/states-class-codes")
    });
};
export default {
    create: create,
    brizaMarkActive: brizaMarkActive,
    upsertDraft: upsertDraft,
    ackQuote: ackQuote,
    submitForManualReview: submitForManualReview,
    update: update,
    createNotification: createNotification,
    getCustomerQuotes: getCustomerQuotes,
    submitLimitApplication: submitLimitApplication,
    getLimitApplicationPolicies: getLimitApplicationPolicies,
    bindLimitApplicationPolicy: bindLimitApplicationPolicy,
    listLimitPolicyDocuments: listLimitPolicyDocuments,
    uploadLimitPolicyDocument: uploadLimitPolicyDocument,
    uploadSubmission: uploadSubmission,
    deleteCustomerSubmissionFiles: deleteCustomerSubmissionFiles,
    listRacetracPolicyDocuments: listRacetracPolicyDocuments,
    uploadSignature: uploadSignature,
    getSignatureDocuments: getSignatureDocuments,
    getBrizaStatesClassCodes: getBrizaStatesClassCodes,
    getPresignedSubmissionUrls: getPresignedSubmissionUrls
};
